import type { ChartService } from "./chart.service";
import { type StablecoinLatestDO } from "../models/pie-chart.models";

export class TableChartService {
  constructor(private chartService: ChartService) { }

  async loadStablecoinsLatest(): Promise<StablecoinLatestDO> {
    return this.chartService.load('latest/stablecoins');
  }
}
